/** Starter README content — edit in the left panel */
export const DEFAULT_MARKDOWN = `# STAYZ Project Ticket Estimation & Costs

This document is for the company **NAHWA AL-GHAD For Information Technology**.  
It contains ticket estimations and costs for each ticket for the **STAYZ Project**.  
**Note:** All costs apply to **Web, Mobile, and Backend changes**, not only the mobile app.

---

## Ticket: STAYZ-686

**Task:** Hide "Property Preferences" section from the profile page  
**Details:**

- Only UI logic
- No backend changes
- Hide section (condition-based rendering)
- Need testing

**Estimated Time:** 1.5–2 hours  
**VizHacks side cost:** €20

---

## Ticket: STAYZ-687

**Task:** Remove sentence displayed at the top of Public View / Account Settings page  

- Only UI logic
- Need testing

**Estimated Time:** ~1 hour  
**VizHacks side cost:** €10

---

## Code samples (syntax highlighting)

Use fenced blocks with a language tag, e.g. \`\`\`python, \`\`\`cpp, \`\`\`bash.

\`\`\`python
def greet(name: str) -> str:
    return f"Hello, \${name}!"

print(greet("STAYZ"))
\`\`\`

\`\`\`cpp
#include <iostream>

int main() {
    std::cout << "Vizhacks MDWriter\\n";
    return 0;
}
\`\`\`

\`\`\`bash
#!/usr/bin/env bash
set -euo pipefail
npm run build && npm run preview
\`\`\`
`;
